import { useLocation } from "react-router";
import useSWR from "swr";
import { z } from "zod";
import { Network } from "@/utils/network";
import { InstagramSearch } from "../types";
import { useInstagramSearch } from "./useInstagramSearch";

const InstagramSearchListsResponseSchema = z.object({
  lists: InstagramSearch.ListSchema.array(),
});

export type InstagramSearchListsResponse = z.output<
  typeof InstagramSearchListsResponseSchema
>;

export const useInstagramSearchLists = () => {
  const config = useInstagramSearch((state) => state.config);
  const location = useLocation();

  return useSWR(
    [config.api.getLists, location.key],
    async ([api]) => {
      const { data } = await Network.get<InstagramSearchListsResponse>(api);

      return InstagramSearchListsResponseSchema.parse(data);
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      shouldRetryOnError: false,
      keepPreviousData: true,
    },
  );
};
